import * as d3 from 'd3';
import React, { useEffect } from 'react';

function Ranges (props) {
    
    const ranges = props.ranges,
        title = props.title,
        {margin,width,height} = props.size,
        unit = (margin.left - margin.gutter)/24,
        format = props.format,
        settings = props.settings,
        types = props.types;

    let ticks = d3.range(-20, 1, 1)

    function scaleRangeToUI (a) {
        let b = d3.scaleLinear()
            .domain([-20, 0])
            .range([unit*2, unit*22])
        return b(a)
    }

    function scaleUIToRange (a) {
        let b = d3.scaleLinear()
            .domain([unit*2, unit*22])
            .range([-20, 0])
        return b(a)
    }

    var drag = d3.drag();
    drag.on('drag',function(e){
            props.setSlot({});
            props.setLocus({});
            d3.select(this).attr("cx", e.x);
            d3.select(this.parentNode).select('line')
                .attr("x1", e.x)
                .attr("x2", e.x);
        })
        .on('end',function(e){
            const thisKey = +d3.select(this).attr("data-key");
            const parentKey = +d3.select(this.parentNode).attr("data-key");
            let newRanges = ranges;

            let mouseKey = scaleUIToRange(e.x);
            let tickKey = ticks.reduce((prev, curr)=>{return (Math.abs(curr - mouseKey) < Math.abs(prev - mouseKey) ? curr : prev);});

            newRanges[parentKey][thisKey] = tickKey;
            newRanges[parentKey].sort(d3.ascending);
            props.setRanges(newRanges);
        })
    
    useEffect(()=>{

        d3.selectAll(".range").each(function(){
            const thisBPs = d3.select(this).selectAll("circle")
            thisBPs.each(function(){d3.select(this).call(drag)})
        })
    })

    return(
            ranges.map((range, n) => {

                function getShade(type, index){
                    if (type === 'pvalue') return settings.colors.pvalue[index]
                    else if (type === 'nominal') return settings.colors.nominal[index]
                }
                
                const type = types[n]
                
                const shades = [
                    {'x': -21,      'width': 21 + range[0],       'color': getShade(type, 0)},
                    {'x': range[0], 'width': range[1] - range[0], 'color': getShade(type, 1)},
                    {'x': range[1], 'width': range[2] - range[1], 'color': getShade(type, 2)},
                    {'x': range[2], 'width': 1 - range[2],        'color': getShade(type, 3)},
                ]

                return <g 
                    id = {`range${n}`}
                    className = "range"
                    data-key = {n}
                    key = {n}
                    >
                        <text
                            x = {0}
                            y = {margin.top + height*n + 22}
                            className = 'mediumText'
                            id = {'chart_BB_'+n}
                        >
                            {format('bb', title[n])}
                        </text>
                        <g id={`range${n}_Ticks`}>
                            {ticks.map(value => {
                                const tickLine = <line
                                    x1 = {scaleRangeToUI(value)}
                                    x2 = {scaleRangeToUI(value)}
                                    y1 = {margin.top + height*n + 43}
                                    y2 = {margin.top + height*n + 40}
                                    className = 'normalLine'
                                    key = {value}
                                />
                                return tickLine
                            })}
                        </g>
                        <g id={`range${n}_Shades`}>
                            {shades.map((value, i) => {
                                const shadeRect = <rect
                                    x = {scaleRangeToUI(value.x)}
                                    y = {margin.top + height*n + 43}
                                    width = {unit * value.width}
                                    height = {10}
                                    fill = {value.color}
                                    key = {i}
                                />
                                return shadeRect
                            })}
                        </g>
                        <g id={`range${n}_Breakpoints`}>
                            {range.map((breakPoint,n_bp,i) => {
                                const breakPointGeometry = <g 
                                    data-key={n}
                                    key={breakPoint}
                                    >
                                        <line
                                            x1 = {scaleRangeToUI(breakPoint)}
                                            x2 = {scaleRangeToUI(breakPoint)}
                                            y1 = {margin.top + height*n + 42}
                                            y2 = {margin.top + height*n + 53}
                                            className = 'normalLine'
                                        />  
                                        <text
                                            x = {scaleRangeToUI(breakPoint)}
                                            y = {margin.top + height*n + 37}
                                            className = 'smallText'
                                            style = {{textAnchor: 'middle'}}
                                        >
                                            {breakPoint}
                                        </text>
                                        <circle
                                            key = {n_bp}
                                            data-key = {n_bp}
                                            className = 'rangeCircle'
                                            cx = {scaleRangeToUI(breakPoint)}
                                            cy = {margin.top + height*n + 48}
                                        />
                                    </g>
                                return breakPointGeometry
                            })}
                        </g>
                        <line
                            x1 = {0}
                            x2 = {unit*24}
                            y1 = {margin.top + height*(n+1)}
                            y2 = {margin.top + height*(n+1)}
                            className = 'normalLine'
                        />
                    </g>
            })
        )
    
}
export default Ranges;